export default __webpack_public_path__ + "static/media/selection-sort.3fc203f3.png";